import { render } from "./ExportsModal.vue?vue&type=template&id=4a4b71fc&ts=true"
import script from "./ExportsModal.vue?vue&type=script&lang=ts"
export * from "./ExportsModal.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__